module.exports = __webpack_public_path__ + "static/crisp-logo-ec79c7b0a39e3411ddecb39fc4256711.png";